module.exports = __webpack_public_path__ + "img/sentio-bg.c24cb610.png";